export default [
  {
    id: "s1",
    titleKey: { zh: "高望看客", en: "High-Rise Observer" },
    audioFile: require('@/assets/audio/high-rise_observer.mp3'),
    descriptionKey: { zh: "情感比较激烈的后摇", en: "Emotional post-rock" },
    genre: { zh: "后摇", en: "Post-rock"},
    date: { year: 2024, month: 1 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s2",
    titleKey: { zh: "海岸后摇v2", en: "Sea Breeze Serenade v2" },
    audioFile: require('@/assets/audio/sea_breeze_serenade_v2.mp3'),
    descriptionKey: { zh: "宁静的", en: "Serene" },
    genre: { zh: "后摇", en: "Post-rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s3",
    titleKey: { zh: "海岸后摇", en: "Sea Breeze Serenade" },
    audioFile: require('@/assets/audio/sea_breeze_serenade.mp3'),
    descriptionKey: { zh: "宁静的", en: "Serene" },
    genre: { zh: "后摇", en: "Post-rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s4",
    titleKey: { zh: "黑暗海域", en: "Shadowed Reign" },
    audioFile: require('@/assets/audio/shadowed_reign.mp3'),
    descriptionKey: { zh: "柔和的摇滚", en: "Soft rock" },
    genre: { zh: "摇滚", en: "Rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s5",
    titleKey: { zh: "心界录暗影角色曲", en: "The Dark Coming" },
    audioFile: require('@/assets/audio/the_dark_coming.mp3'),
    descriptionKey: { zh: "激烈的摇滚", en: "Intense rock" },
    genre: { zh: "摇滚", en: "Rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s6",
    titleKey: { zh: "三角海", en: "The Delta Sea" },
    audioFile: require('@/assets/audio/the_delta_sea.mp3'),
    descriptionKey: { zh: "悠长的摇滚", en: "Flowing rock" },
    genre: { zh: "摇滚", en: "Rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s7",
    titleKey: { zh: "三角海v2", en: "The Delta Sea v2" },
    audioFile: require('@/assets/audio/the_delta_sea_v2.mp3'),
    descriptionKey: { zh: "比上面的版本要热烈，歌词一样", en: "A more passionate than the above version, with the same lyrics" },
    genre: { zh: "摇滚", en: "Rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  },
  {
    id: "s8",
    titleKey: { zh: "三角海v3", en: "The Delta Sea v3" },
    audioFile: require('@/assets/audio/the_delta_sea_v3.mp3'),
    descriptionKey: { zh: "女声热烈摇滚，歌词不同的", en: "A female vocals rock and roll, with different lyrics" },
    genre: { zh: "摇滚", en: "Rock"},
    date: { year: 2025, month: 3 },
    lyricsKey: {
       zh: "（无歌词）",
       en: "(No lyrics)"
    }
  }
]
